export default __webpack_public_path__ + "static/media/lgb-how-cover.20d9385a.jpg";